module.exports = __webpack_public_path__ + "static/media/undraw_happy_announcement_ac67.185c34d1.png";